import React, { useState, useEffect, useContext } from "react";
import { StateContext } from "../utils/context";
import { Button, Alert } from "reactstrap";
import { getCookie } from "../jwt/_helpers/cookie";
import SubscriptionConfirmModal from "../components/subscriptionConfirmModal";
import LoaderInner from "../components/LoaderInner";
import InfoMessageTooltip from "../views/subscription/infoMessageTooltip";
import { useTranslation } from "react-i18next";

import "../views/subscription/subscriptionUpgrade.css";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const SubscriptionTiersNew = () => {
  const token = getCookie("token");
  const {currentUser} = useContext(StateContext);
  const { t } = useTranslation();

  const [tiers, setTiers] = useState([]);
  const [newTier, setNewTier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openModal, setToggleModal] = useState(false);

  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json"
    }
  };

  useEffect(() => {
    fetch(`${API_URL}subscription-tiers/`, options)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        let subTiers = data.results;
        subTiers = subTiers.sort((a, b) => a.order - b.order);
        setTiers(subTiers);
        setLoading(false);
      })
      .catch(error => {
        console.error('An error occured while fetching subscription tiers:', error);
        setError('Failed to load subscription tiers');
        setLoading(false);
      });
    }, []);

  if (loading) return <LoaderInner show={loading} />;
  if (error) return <Alert color="danger">{t("subscription.subscriptionTiers.message.error")}</Alert>;

  return (
    <div>
        <div className="subscription-upgrade mb-3">
            <h2>{t("subscription.subscriptionTiers.form.title")}</h2>
            <div className="pricing-cards mt-3">
            {tiers.map((tier) => (
                <div key={tier.id} className="subscription-card" style={{border: `1px solid ${tier.primary_color}`}}>
                <div className="subscription-card-ribbon-container">
                    <div className="subscription-card-ribbon" style={{background: tier.ribbon_color, color: tier.ribbon_text_color}}>{tier.ribbon_text}</div>
                </div>
                <h3>{tier.name}</h3>
                <p className="tier-price-container"><span className="price" style={{color: tier.primary_color}}>{tier.price}</span><br/>{tier.price_info_message}</p>
                <ul>
                    {(tier?.stitems || []).map((tierItem) => (
                    <li style={{ lineHeight: "20px" }}>
                        <strong>
                        {tierItem.name}
                        {tierItem.info_message.length > 0 && (
                            <>
                            <i className="ml-1 tooltip-icon mdi mdi-18px mdi-help-circle" style={{ verticalAlign: "middle"}} id={`ti-${tier.id}-${tierItem.order}`}></i>
                            <InfoMessageTooltip target={`ti-${tier.id}-${tierItem.order}`} infoMessage={tierItem.info_message} />
                            </>
                        )}
                        </strong>
                        {tierItem.enabled ?
                        <i className="fas fa-check-circle float-right" style={{ color: tier.primary_color, fontSize: "15px", marginTop: "2px" }}></i> :
                        <i className="fas fa-times-circle float-right" style={{ color: tier.secondary_color, fontSize: "15px", marginTop: "2px" }}></i>
                        }
                    </li>
                    ))}
                    <li><strong>Track Allowance</strong> <strong style={{color: tier.primary_color}} className="float-right">{tier.track_allowance}</strong></li>
                    <li><strong>Music Link Allowance</strong> <strong style={{color: tier.primary_color}} className="float-right">{tier.music_link_allowance}</strong></li>
                    <li><strong>Link Landing Page Allowance</strong> <strong style={{color: tier.primary_color}} className="float-right">{tier.link_landing_page_allowance}</strong></li>
                </ul>
                <Button
                  style={{
                    backgroundColor: tier.primary_color,
                    '--hover-bg-color': tier.secondary_color,
                  }}
                  className="btn btn-ml"
                  onClick={() => {
                    setToggleModal(true)
                    setNewTier(tier)
                  }}
                >
                  <b>{t("subscription.subscriptionTiers.form.button.startNow")}</b>
                </Button>
                </div>
            ))}
            </div>
            {openModal && (
              <SubscriptionConfirmModal
                openModal={openModal}
                setToggleModal={setToggleModal}
                currentUser={currentUser}
                priceID={newTier.price_id}
                setError={setError}
              />
            )}
        </div>
    </div>
  );
}

export default SubscriptionTiersNew;